import React from 'react';
import './Pages.css';

const AboutPage = () => {
  return (
    <div className="container fade-in-up">
      <div className="section-title">About No Joke Lottery</div>
      
      <div className="about-highlight">
        <h3>Our Motive: Radical Honesty</h3>
        <p className="justify-text">Founded in 2022, "No Joke Lottery Company" was born from a simple idea: the lottery industry needs a revolution of trust. As an official partner of the National Lottery Authority (NLA), we are not just another gaming company; we are a movement focused on ethical entertainment, player protection, and sustainable impact. Our name reflects our promise — we don't joke about your money, your dreams, or your future. Operating with integrity from our headquarters in Denu Tokor, near St. Paul's Senior High School, Volta Region, Ghana, we're setting new standards for the Ghanaian lottery industry.</p>
        <p className="justify-text">We operate with a strict code: zero hidden clauses, instant payouts in Ghana Cedis (GH₵), and a dedicated player-first approach. Our long-term plans include launching financial literacy programs, responsible gaming tools, and expanding our agent network across all regions of Ghana.</p>
      </div>

      <div className="values-grid">
        <div className="value-card">
          <i className="fas fa-eye"></i>
          <h3>Transparency First</h3>
          <p className="justify-text">Live draws, independent observers, and real-time result streaming. Every transaction is clear and traceable with NLA oversight.</p>
        </div>
        <div className="value-card">
          <i className="fas fa-users"></i>
          <h3>Community Driven</h3>
          <p className="justify-text">Players and agents vote on community initiatives and local projects. Your voice shapes our future.</p>
        </div>
        <div className="value-card">
          <i className="fas fa-seedling"></i>
          <h3>Sustainable Future</h3>
          <p className="justify-text">Supporting local education and healthcare initiatives across the Volta Region and beyond.</p>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;